require('./bootstrap');

window.Dropzone.autoDiscover = false;
